import LabelFooter from 'components/common/Chart/LabelFooter';
import { formatMoney } from 'Helpers/helpFunction';
import useHelper from 'hook/useHelper';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ChartColumn from './ChartColumn';
import { options2 } from './ChartColumnConfig2';

export default function RightChartColumn() {
  const AnalysisStore = useSelector((state: any) => state?.AnalysisStore)
  const profitDeviant = formatMoney(AnalysisStore?.backtest?.detailBacktest?.profitDeviant, 2) || 0
  const [FilterLabel, setFilterLabel] = useState<any>([])
  const { handleFilterArray } = useHelper();

  const handleChangeFilterLabel = (value: string) => {
    const FilterLabelNew: any = handleFilterArray(value, FilterLabel)
    setFilterLabel([...FilterLabelNew])
  }

  return (
    <div className='wqMRDqIsjW'>
      <div className='tlGDFJiuQq'>
        <div className='bWIzOZvMDO'>Cổ phiếu: <span className='DrekZQvFok'>{AnalysisStore?.backtest?.detailBacktest?.ticker}</span></div>
        <div className='WtyqiTevzN'>
          <div className='QWwAgajUIw'>
            <div className='JfegHbSXGJ'>Tăng trưởng:<span className='jUmqKvrUAO'>{AnalysisStore?.backtest?.detailBacktest?.growthRank}</span></div>
            <div className='IFufcdLBjM'>Động lượng:<span className='zPjquGVwff'>{AnalysisStore?.backtest?.detailBacktest?.momentumRank}</span></div>
          </div>
        </div>
      </div>
      <div className='bYdIiOwZCA'>
        <ChartColumn options={options2(AnalysisStore?.backtest)} />
        <div className='fsvznangnu'>
          {/* <img src={iconChenh} className="NGWXkmJtAR" alt="" /> */}
          <div className='hlfooqfkso'>
            <div className='tmtecxnqct'>Chênh lệch</div>
            <div className='elimvegmxe' style={{ color: profitDeviant > 0 ? '#2ad03d' : '#ff4230' }}>
              {profitDeviant}%
            </div>
          </div>
        </div>
        <LabelFooter selectData={(value: string) => handleChangeFilterLabel(value)}
          listDefault={FilterLabel}
          data={[
            { name: 'LN trung bình nhóm cùng kỳ', color: '#2C69B9' },
            { name: 'LN cổ phiếu từ đầu kỳ', color: '#FFC400' },
          ]} />
      </div>
    </div>
  )
}